export interface UnboxItem {
  id: string;
  name: string;
  price: string;
  netWeight: string;
  score: number;
  verdict: "推荐回购" | "可以尝鲜" | "谨慎选择";
  pros: string[];
  cons: string;
  shelfLife: string;
  image: string;
}

export const unboxings: UnboxItem[] = [
  {
    id: "u1",
    name: "冷冻麻辣小龙虾 1.5kg 装",
    price: "¥99",
    netWeight: "1500g（含汤汁）",
    score: 4.2,
    verdict: "可以尝鲜",
    pros: ["虾体完整率约九成", "加热十分钟即可食用", "蒜香层次明显"],
    cons: "壳偏软，弹牙感弱于堂食",
    shelfLife: "冷冻 180 天",
    image:
      "https://readdy.ai/api/search-image?query=Spicy%20crayfish%20in%20a%20sealed%20frozen%20food%20tray%20being%20unboxed%2C%20glossy%20red%20coat%2C%20clean%20neutral%20background%2C%20bright%20product%20unboxing%20photography%2C%20high%20detail&width=800&height=600&seq=unbox-crayfish-21&orientation=landscape",
  },
  {
    id: "u2",
    name: "自热火锅六盒组合装",
    price: "¥69",
    netWeight: "6 × 350g",
    score: 4.0,
    verdict: "可以尝鲜",
    pros: ["六种口味不重复", "发热包稳定安全", "宽粉吸汤入味"],
    cons: "主食易糊底，建议先放蔬菜",
    shelfLife: "常温 12 个月",
    image:
      "https://readdy.ai/api/search-image?query=Six%20self%20heating%20hot%20pot%20boxes%20arranged%20in%20a%20row%20during%20unboxing%2C%20steam%20rising%20from%20one%2C%20clean%20neutral%20background%2C%20bright%20product%20photography&width=800&height=600&seq=unbox-self-heat-hotpot-22&orientation=landscape",
  },
  {
    id: "u3",
    name: "手工黑糖麻薯礼盒",
    price: "¥58",
    netWeight: "8 枚 / 480g",
    score: 4.6,
    verdict: "推荐回购",
    pros: ["黑糖香气足", "麻薯回弹好不粘牙", "独立包装适合分享"],
    cons: "常温下两小时内食用最佳",
    shelfLife: "常温 7 天",
    image:
      "https://readdy.ai/api/search-image?query=Soft%20brown%20sugar%20mochi%20in%20an%20elegant%20gift%20box%2C%20chewy%20texture%2C%20soft%20warm%20daylight%2C%20minimal%20beige%20background%2C%20refined%20food%20unboxing%20photography&width=800&height=600&seq=unbox-brown-sugar-mochi-23&orientation=landscape",
  },
  {
    id: "u4",
    name: "现烤盐可颂冷冻装",
    price: "¥39",
    netWeight: "6 枚 / 360g",
    score: 4.4,
    verdict: "推荐回购",
    pros: ["复烤后外脆内软", "黄油香浓郁", "性价比高于现烤门店"],
    cons: "需提前解冻，不适合即食",
    shelfLife: "冷冻 90 天",
    image:
      "https://readdy.ai/api/search-image?query=Frozen%20salt%20croissants%20arranged%20in%20a%20box%20ready%20to%20bake%2C%20golden%20flaky%20layers%2C%20clean%20neutral%20background%2C%20bright%20bakery%20product%20photography&width=800&height=600&seq=unbox-salt-croissant-24&orientation=landscape",
  },
];